import React from 'react';
import { LayoutGrid, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ChartCategorySidebar = ({ categories, activeCategory, setActiveCategory }) => {
    const { t } = useTranslation('layout');
    return (
        <aside className="w-full h-full bg-white border-r border-gray-100 flex flex-col">
            <div className={`p-theme border-b border-gray-50`}>
                <div className={`flex items-center gap-theme text-primary-600`}>
                    <LayoutGrid className="w-5 h-5" />
                    <span className="font-bold text-lg">{t('chartCategorySidebar.categories')}</span>
                </div>
            </div>
            <nav className={`flex-1 p-theme overflow-y-auto`}>
                <div
                    className="rounded-lg p-1 flex flex-col gap-1 border border-black/[0.02]"
                    style={{ backgroundColor: '#eceef1' }}
                >
                    {categories.map((cat) => {
                        const active = activeCategory === cat.name;
                        return (
                            <button
                                key={cat.name}
                                type="button"
                                onClick={() => setActiveCategory(cat.name)}
                                className={`w-full flex items-center justify-between rounded-md px-3 py-2 text-sm font-medium transition-all duration-150 group ${active
                                    ? 'bg-white text-gray-900 border border-gray-200 shadow-none'
                                    : 'text-gray-600 border border-transparent hover:bg-white/40 hover:text-gray-900'
                                    }`}
                            >
                                <div className={`flex items-center gap-theme`}>
                                    <cat.icon className={`w-4 h-4 shrink-0 ${active ? 'text-gray-900' : 'text-gray-400 group-hover:text-gray-600'}`} />
                                    <span>{cat.name}</span>
                                </div>
                                {active && <ArrowRight className="w-3 h-3 text-gray-500 shrink-0" />}
                            </button>
                        );
                    })}
                </div>
            </nav>
        </aside>
    );
};

export default ChartCategorySidebar;
